import { reducer } from './reducer';

export * from './actions';
export * as confirmSelectors from './selectors';

export default reducer;
